import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faDownload,
  faSortAmountDown,
  faSortAmountUp,
} from "@fortawesome/free-solid-svg-icons";

const WithdrawalFilters = ({
  search,
  onSearchChange,
  resourcePersonId,
  resourcePersons = [],
  onResourcePersonIdChange,
  statusFilter,
  onStatusFilterChange,
  limit,
  onLimitChange,
  sortOrder,
  onSortToggle,
  onExport,
}) => {
  return (
    <div className="flex gap-3 flex-wrap items-center mb-4">
      <div className="flex-1 min-w-[200px] flex items-center gap-2 border border-gray-200 rounded-lg p-2.5 bg-white">
        <FontAwesomeIcon icon={faSearch} className="text-gray-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search loaded requests by resource person..."
          className="border-none outline-none flex-1 text-sm text-gray-700"
        />
      </div>
      <select
        value={resourcePersonId}
        onChange={(e) => onResourcePersonIdChange(e.target.value)}
        className="min-w-[220px] px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white"
      >
        <option value="">All Resource Persons</option>
        {resourcePersons.map((person) => (
          <option key={person.id} value={person.id}>
            {person.name || person.fullName || person.email || "Unnamed"}
          </option>
        ))}
      </select>
      <select
        value={statusFilter}
        onChange={(e) => onStatusFilterChange(e.target.value)}
        className="px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white"
      >
        <option value="">All Statuses</option>
        <option value="REQUESTED">Requested</option>
        <option value="APPROVED">Approved</option>
        <option value="AWAITING_FUNDS">Awaiting funds</option>
        <option value="PROCESSING">Processing</option>
        <option value="COMPLETED">Completed</option>
        <option value="FAILED">Failed</option>
        <option value="REJECTED">Rejected</option>
        <option value="CANCELLED">Cancelled</option>
      </select>
      <select
        value={limit}
        onChange={(e) => onLimitChange(Number(e.target.value))}
        className="px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white"
      >
        <option value={10}>10 per page</option>
        <option value={25}>25 per page</option>
        <option value={50}>50 per page</option>
      </select>
      <button
        onClick={onSortToggle}
        className="px-3 py-2 border border-gray-200 rounded-lg bg-white cursor-pointer text-sm"
      >
        <FontAwesomeIcon
          icon={sortOrder === "newest" ? faSortAmountDown : faSortAmountUp}
          className="mr-1.5"
        />
        {sortOrder === "newest" ? "Newest" : "Oldest"}
      </button>
      <button
        onClick={onExport}
        className="px-4 py-2 border border-gray-200 rounded-lg bg-white cursor-pointer text-sm font-medium"
      >
        <FontAwesomeIcon icon={faDownload} className="mr-1.5" />
        Export CSV
      </button>
    </div>
  );
};

export default WithdrawalFilters;
